import * as suggestionsApi from '../api/suggestions'
import { handleApiError } from './api-errors'
import { showSuccess } from './alerts'

export const createSuggestion = (text) => (dispatch) => {
    suggestionsApi.putObj({
        text: text
    })
    .then(dispatch(showSuccess("Message sent. Thank you for your thoughts!")))
    .catch(err => dispatch(handleApiError(err)))
}
